export enum SubmitDialog {
  Save = 'save',
  Quote = 'quote',
  Checkout = 'checkout',
}
